import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { Box, Button, Card, CardContent, CardActions, Grid, Link, Typography } from "@mui/material";

import Footer from "../components/footer";
import Header from "../components/header";
import { productList } from "../components/productList";
import { categoryList } from "../components/categoryList";

import "./home.scss";

export default function Home() {
  const navigate = useNavigate();

  const goToProductPage = (id) => { 
    navigate(`/product/${id}`);
  }

  return (<HelmetProvider>
    <Helmet title="Home"/>
    <Header />
    <Box className="homeBackground" sx={{ padding: 0, backgroundPosition: "top", backgroundSize: "cover" }} >
      <Box sx={{ width: "100%", overflowY: "auto", maxHeight: "calc(100vh - 70px)", textAlign: "-webkit-center" }}>
        <Box className="homeScroll" sx={{ borderRadius: "6px", backgroundColor: "white", padding: "20px", maxWidth: "1280px", textAlign: "left" }}>
          <h1>Newest Release</h1>
          <Link href="/product/51"><img style={{ float: "right", padding: "0 20px" }} height="250px" src="/images/conquering.jpg" alt="Conquering Our Common Enemy cover" /></Link>
          <Typography>We are pleased to announce the release of our newest book, <b><i>Conquering Our Common Enemy—How Our Savior Can Help Us Overcome Evil</i></b>.</Typography>
          <Typography>This timely book answers the age-old question of how we can <b>reduce</b> and <b>remove</b> the influence of the enemy in our lives.</Typography>
          <ul><li><Typography>What <b>traps</b> and <b>snares</b> does the enemy use?</Typography></li>
          <li><Typography>How does <b>our Savior help us</b> in this journey to rid ourselves of the enemy’s influence?</Typography></li>
          <li><Typography>How can we <b>bind</b> the enemy and lessen the effect of his <b>temptations</b> and his messages of <b>accusation</b> and <b>despair</b>?</Typography></li></ul>
          <Typography><Link href="/product/51">Click here</Link> to find out more about this inspiring and hope-filled new book.</Typography>
          <Typography>You can also read an <b>exclusive interview</b> with the author about this new release <Link href="/interview">by clicking here</Link>.</Typography>
          <h1>Our Products</h1>
          <Typography>Our authors have covered many different subjects in the books they have written, which are divided into the following categories:</Typography>
          {categoryList.filter(c => c.Hidden === false).sort((a, b) => a.Priority < b.Priority ? -1 : 1)
            .map((category, cIndex) => (<div key={cIndex}>
              <h2>{category.Name}</h2>
              <Grid container spacing={3}>
                {productList.filter(p => p.Hidden === false && p.CategoryIDs.includes(category.CategoryID))
                .sort((a, b) => a.Popularity < b.Popularity ? -1 : 1)
                .map((product, index) => (
                  <Grid item xs={6} sm={2} key={index}>
                    <Card elevation={8}>
                      <Box sx={{ margin: "20px 15px 0 15px" }}>
                        <Link href={`/product/${product.ProductID}`}>
                          <img style={{ borderRadius: "6px", width: "100%", boxShadow: "5px 5px 5px 0px rgb(0 0 0 / 50%)" }}
                              src={`/images/${product.ImageURL}`} alt={product.Title} />
                        </Link>
                      </Box>
                      <CardContent>
                        <Typography variant="h7" component="div" textAlign="center" sx={{marginBottom: "10px"}}>{product.ShortTitle}</Typography>
                        <Typography variant="caption">{product.ShortText}</Typography>
                      </CardContent>
                      <CardActions sx={{ display: "block" }}>
                        <Button size="small" sx={{ float: "right" }} onClick={() => goToProductPage(product.ProductID)}>Learn More</Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </div>))}
        </Box>
        <Footer />
      </Box>
    </Box>
  </HelmetProvider>);
}